<!--
PvctapeSticker
PVC透明胶贴纸
-->

<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="贴纸 > PVC透明胶贴纸" name="PVC透明胶贴纸">
        <el-row>
          <el-col :span="24">
            <el-form :label-position="labelPosition" :model="pvctapeSticker" label-width="80px">
              <el-form-item label="尺寸">
                <el-radio-group v-model="pvctapeSticker['尺寸']">
                  <el-radio-button label="9.8*15">9.8*15</el-radio-button>
                  <el-radio-button label="自定义尺寸">自定义尺寸</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="自定尺寸" v-if="pvctapeSticker['尺寸']=='自定义尺寸'">
                <el-row type="flex" class="row-bg">
                  <el-col :span="12">
                    <el-input v-model="bpvctapeSticker['尺寸宽']" placeholder="宽 cm"></el-input>
                  </el-col>
                  <el-col :span="12" :offset="0">
                    <el-input v-model="pvctapeSticker['尺寸长']" placeholder="长 cm"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="款式">
                <el-input v-model="pvctapeSticker['款式']" placeholder="请填写您选择的款式"></el-input>
              </el-form-item>
              <el-form-item label="数量" :inline="true">
                <el-input-number v-model="pvctapeSticker['数量']" :min="500" label="数量"></el-input-number>
                <el-alert
                  title="单款起定数为500"
                  type="info"
                  show-icon
                  class="el-alert__title"
                  style="padding: 8px 16px; margin: 20px 0 0 0;"
                ></el-alert>
              </el-form-item>
              <el-form-item label="模切">
                <el-select v-model="pvctapeSticker['模切']" placeholder="模切">
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="覆膜">
                <el-select v-model="pvctapeSticker['覆膜']" placeholder="覆膜">
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="工艺">
                <el-radio-group v-model="pvctapeSticker['工艺']">
                  <el-radio-button label="烫金">烫金</el-radio-button>
                  <el-radio-button label="无工艺">无工艺</el-radio-button>
                  <el-radio-button label="其他（请咨询客服）">其他（请咨询客服）</el-radio-button>
                </el-radio-group>
                <div style="padding:10px"></div>
                <el-alert
                  title="其他工艺请联系客服。"
                  type="info"
                  show-icon
                  class="el-alert__title"
                  style="padding: 8px 16px; margin: 3px 0 0 0;"
                ></el-alert>
              </el-form-item>
              <el-button v-on:click="addEvent()">提交</el-button>
              <el-button v-on:click="clear()">清空</el-button>
            </el-form>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
export default {
  name: "PvctapeSticker",
  data() {
    return {
      forcollapse: ["allsame"],
      pvctapeSticker: {
        title: "PVC透明胶贴纸",
        工艺: []
      },
      labelPosition: "left"
    };
  },
  methods: {
    addEvent() {
      this.$root.add(this.pvctapeSticker);
    },
    clear() {
      this.$root.clearAlert();
      this.pvctapeSticker = {
        title: "PVC透明胶贴纸",
        工艺: []
      };
    }
  }
};
</script>
<style scoped>
</style>